module.exports = "/images/Brazil.png?1908f74850b3ae5abcc869cfcd44c293";